import { YourIR } from 'yourir-next';

export default function AsxLatestAnnouncement(props)
{
    const { image, className } = props;

    return (
        <YourIR>
            <div data-yourir="announcements filter=annualReports pageSize=1" className={ "mb-30" + ( className ? " " + className : "" ) }>
                <a className="inline-flex items-center rounded border-3 border-grey bg-white p-30 cursor-pointer no-underline hover:underline">
                    <span className="block relative border border-grey-2 w-[140px]">
                        { image }
                    </span>
                    <span className="mx-30">View Our Latest Report</span>
                </a>
            </div>
        </YourIR>
    );
}